var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_vm._v(" Hola mundo nota fe ampliac "),_c('CMatSeccionTree')],1)}
var staticRenderFns = []

export { render, staticRenderFns }